<template>
  <!-- <div id="workbench"></div> -->
  <div id="reviews-detail">
    <div class="ipub-h1 relative mar-b-10">
      Reviews Details
    </div>
    <div v-for="(item,index) in responseData"
         :key="index"
         @click="togalReport(item,'showReport')">
      <div class="ipub-h5 relative mar-b-10 ipub-title-tab">
        <!-- Report - {{decisionStatus[responseData.decisionStatus]}} <span>(Report sent on {{$moment(responseData.completedTime).format('DD MMMM YYYY')}})</span> -->
        Report {{responseData.length-index}}
        <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',!item.showReport?'rotate-180':'']"
                   type="iconArrow" />
      </div>
      <div v-if="!item.showReport">
        <div class="mar-b-12">
          <span style="margin-right:12px;"
                class="ipub-p1">Reviewer Decision <font class="key-color">*</font></span> <span class="ipub-p1">{{decisionStatus[item.decisionStatus]}}</span>
        </div>
        <div class="mar-b-20">
          <div class="mar-b-20">
            <div class="ipub-p1 relative mar-b-10">
              Custom Review Questions
            </div>
            <ipub-row :gutter="30">
              <ipub-col :span="6"
                        :key="indexque"
                        v-for="(itemque,indexque) in item.questionList">
                <div class="ipub-block mar-b-6"
                     style="padding: 12px 24px; border-radius: 4px">
                  <div class="common question">
                    <span class="ipub-p1 color tag">Q: </span>
                    <span class="ipub-p1 color">{{itemque.questionContent}}</span>
                  </div>
                  <div class="common answer ">
                    <span class="ipub-p2 color tag">A: </span>
                    <span class="ipub-p2 color">{{itemque.answer || (itemque.type ==='SINGLE' ? JSON.parse(itemque.questionOption)[itemque.checkedOption].answer : itemque.checkedOption)}}</span>
                  </div>
                </div>
              </ipub-col>
            </ipub-row>
          </div>

          <div>
            <div class="ipub-p1 relative mar-b-10"
                 style="cursor:pointer">
              Comments to Editor
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',!item.showEditor?'rotate-180':'']"
                         @click="togalReport(item,'showEditor')"
                         type="iconArrow" />
            </div>
            <div class="ipub-p4 mar-b-20 "
                 v-if="!item.showEditor">
              <div class="ipub-p4"
                   v-if="item.editorNotes"
                   v-html="item.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
              <template v-else>
                <div class="line-color">No notes or comments.</div>
              </template>

            </div>
          </div>

          <div>
            <div class="ipub-p1 relative mar-b-10"
                 style="cursor:pointer">
              Comments to Author
              <i class="key-color">*</i>
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',!item.showAuthor?'rotate-180':'']"
                         @click="togalReport(item,'showAuthor')"
                         type="iconArrow" />
            </div>
            <div class="ipub-p4 mar-b-20"
                 v-if="!item.showAuthor">
              <div class="ipub-p4"
                   v-if="item.authorNotes"
                   v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
              <template v-else>
                <div class="line-color">No notes or comments.</div>
              </template>

            </div>
          </div>

          <div v-if="item.reviewerFileList && item.reviewerFileList.length>0">
            <div class="file-contain">
              <span class="ipub-p1 relative"
                    style="margin-right:12px;line-height:30px">Attachment(s)</span>
              <ipub-label size="small"
                          style="align-items: center;height:30px;margin-right:12px;cursor:pointer;background:#fff;border:none;cursor:pointer"
                          v-for="(itemfile) in item.reviewerFileList"
                          :key="itemfile.id"
                          @click="download(itemfile)">
                {{itemfile.name}}
              </ipub-label>
            </div>
          </div>
        </div>
        <!-- 作者回复 -->
        <div class="mar-b-40"
             style="border-top: 1px solid #D8E3E7;padding-top:20px">
          <div class="ipub-p1 relative mar-b-10"
               style="cursor:pointer"
               v-if="item.authorReply || (item.authorReplyFileList && item.authorReplyFileList.length>0)">
            Author’s Response to Report {{responseData.length-index}}
            <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',!item.showReply?'rotate-180':'']"
                       @click="e => togalReport(item,'showReply')"
                       type="iconArrow" />
          </div>
          <div v-if="!item.showReply">
            <div v-if="item.authorReply">
              <div class="ipub-p1 relative mar-b-10"
                   style="cursor:pointer">
                Author’s Response
              </div>
              <div class="ipub-p4 mar-b-30 font-color">
                {{item.authorReply}}
              </div>
            </div>

            <div v-if="item.authorReplyFileList && item.authorReplyFileList.length>0">
              <div class="file-contain">
                <span class="ipub-p1 relative mar-b-30"
                      style="margin-right:12px;line-height:30px">Author’s Response File</span>
                <ipub-label size="small"
                            class="ipub-cursor-pointer"
                            style="align-items: center;height:30px;margin-right:12px;;cursor:pointer;"
                            type="link"
                            v-show="itemReply.authorShowed"
                            v-for="(itemReply) in item.authorReplyFileList"
                            :key="itemReply.id"
                            @click="download(itemReply)">
                  {{itemReply.name}}
                </ipub-label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mar-b-40">
      <ipub-button type="primary"
                   plain
                   :style="{ minWidth: '150px' }"
                   @click="back()">Back</ipub-button>
    </div>
  </div>
</template>



<script>
import main from './main'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';

.file-contain {
  display: flex;
  display: flex;
  flex-wrap: wrap;

  .file-list {
    align-items: center;
    flex-wrap: wrap;

    .file-item {
      height: 40px;
      background: $content_color;
      border-radius: 4px;
      padding: 0 12px;
      box-sizing: border-box;
      color: #1b65a6;
      line-height: 40px;
      border: 1px solid #1b65a6;
    }
  }
}
</style>
